/**
 *
 * 优惠券倒计时显示样式
 * Author:   zhoumh
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2020/12/21      1.0     First version
 *
 * Copyright  2020/12/21 , all rights reserved. Essa.cn
 * */
import "./index.less";
import React from "react";
class CouponCountDown extends React.Component{
    constructor(props) {
        super(props);
        this.window = props.serverWindow ? props.serverWindow : window;
        this.state = {
            remainSeconds:this.props.remainSeconds||0 //剩余的倒计时毫秒数
        };
    }

    /**
     * 切割字符串
     * @param remainSeconds
     */
    /*getData(remainSeconds){
        let day=0,hourer=0,minuteser=0,secondser=0;
        if (remainSeconds > 0) {
            //因为moment 相隔天数 少了月份的值 所以天数要重算
            var duration = moment.duration(remainSeconds, 'seconds')._data;
            day = parseInt(moment.duration(remainSeconds * 1000).asDays());
            if (day > 0 && day < 10) {
                day = "0" + day;
            }
            //小于10 补0
            if (duration.hours < 10) {
                hourer = "0" + duration.hours;
            } else {
                hourer = duration.hours;
            }
            if (duration.minutes < 10) {
                minuteser = "0" + duration.minutes;
            } else {
                minuteser = duration.minutes;
            }
            if (duration.seconds < 10) {
                secondser = "0" + duration.seconds;
            } else {
                secondser = duration.seconds;
            }
        }
        return {
            day:day,
            hourer:hourer,
            minuteser:minuteser,
            secondser:secondser
        }
    }*/

    render(){
        // let date = this.getData(this.state.remainSeconds).day;
        let day = this.props.remainingDays;
        let item = this.props.item;
        return (
            <div className="coupon-count-down">
                {
                    item.isTodayExpire!=1?
                        <span>{item.isPrepareExpire==1?`${__getServerLanguage('JiJiangGuoQi')}:`:''}{__getServerLanguage('HaiShengNTian',day)}</span>
                        :
                        <span>{__getServerLanguage('JinTianGuoQi')}</span>
                }
            </div>
        )
    }
}

CouponCountDown.defaultProps = {
    //剩余的倒计时毫秒数
    remainSeconds:0,
    //剩余多少天
    remainingDays:null,
    item:{}
}

CouponCountDown.propTypes = {

}
export default CouponCountDown;
